<template>
  <div class="bottom-nav">
    <button
      class="btn"
      @click="$emit('click-first')"
    >
      <slot name="first" />
    </button>
    <button
      class="btn"
      @click="$emit('click-second')"
    >
      <slot name="second" />
    </button>
  </div>
</template>

<script>
export default {
  name: "AppBottomNav"
};
</script>

<style lang="scss" scoped>
.bottom-nav {
  background-color: transparent;
  overflow: hidden;
  position: fixed;
  bottom: 10px;
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;

  .btn {
    outline: none;
    width: 50%;
    text-transform: uppercase;
    font-weight: 700;
    background-color: #880e4f;
    color: #fff;
    height: 56px;
    border-radius: 15px;
    margin: 0 15px;
  }
}
</style>
